<script>
import { useAlert } from 'dashboard/composables';

export default {
  components: {},
  props: {
    inboxId: {
      type: Number,
      required: true,
    },
    timeOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      teimosinhaEnabled: false,
      privateMessage: true,
      messageContent: '',
      messageTime: 3600, // Default of 1 hour
      isLoading: false,
      teimosinha_type: 1,
      unassign_conversations: false,
    };
  },
  computed: {
    firstMessagePossibleTimes() {
      return [...this.timeOptions];
    },
  },
  mounted() {},
  methods: {
    async createTeimosinhaMessage() {
      const payload = {
        inboxId: this.inboxId,
        teimosinhaSettings: {
          content: this.messageContent,
          time_to_send_seconds: this.messageTime,
          private_message: this.privateMessage,
          teimosinha_type: this.teimosinha_type,
          unassign_conversation: this.unassign_conversations,
        },
      };
      try {
        this.isLoading = true;
        await this.$store.dispatch('inboxes/createTeimosinhaMessage', payload);
        this.isLoading = false;
        this.onClose();
        useAlert(
          this.$t('INBOX_MGMT.TEIMOSINHA.CREATE_MESSAGE.API.SUCCESS_MESSAGE')
        );
      } catch (error) {
        useAlert(
          this.$t('INBOX_MGMT.TEIMOSINHA.CREATE_MESSAGE.API.ERROR_MESSAGE')
        );
        this.isLoading = false;
      }
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<template>
  <div class="h-auto overflow-auto flex flex-col">
    <woot-modal-header
      :header-title="$t('INBOX_MGMT.TEIMOSINHA.CREATE_MESSAGE.HEADER')"
    />
    <form class="mx-0 flex flex-wrap" @submit.prevent="createTeimosinhaMessage">
      <!-- TIME WITHOUT RESPONSE -->
      <div>
        <label>
          {{
            $t(
              'INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.TIME_WITHOUT_RESPONSE.HEADER'
            )
          }}
        </label>
        <span class="text-xs">
          {{
            $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.TIME_WITHOUT_RESPONSE.INFO')
          }}
        </span>
        <select v-model="messageTime">
          <option
            v-for="time in timeOptions"
            :key="time.key"
            :value="time.key"
            :disabled="time.disabled"
          >
            {{ time.name }}
          </option>
        </select>
      </div>
      <!-- MESSAGE CONTENT -->
      <woot-input
        v-model.trim="messageContent"
        v-tooltip.bottom="messageContent"
        class="w-full"
        :label="$t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.MESSAGE_CONTENT.HEADER')"
        :placeholder="
          $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.MESSAGE_CONTENT.PLACE_HOLDER')
        "
      />
      <div class="flex items-center pl-2">
        <input
          id="unassign_conversations"
          v-model="unassign_conversations"
          class="!my-0 mr-2 ml-0"
          type="checkbox"
        />
        <label class="text-sm" for="unassign_conversations">
          {{
            $t(
              'INBOX_MGMT.TEIMOSINHA.ADDITIONAL_SETTINGS.UNASSIGN_CONVERSATIONS'
            )
          }}
        </label>
      </div>
      <div class="flex justify-end items-center py-2 px-0 gap-2 w-full">
        <woot-button :is-loading="isLoading">
          {{ $t('INBOX_MGMT.TEIMOSINHA.CREATE_MESSAGE.BUTTONS.CREATE') }}
        </woot-button>
        <woot-button
          :is-loading="isLoading"
          class="button clear"
          @click.prevent="onClose"
        >
          {{ $t('INBOX_MGMT.TEIMOSINHA.CREATE_MESSAGE.BUTTONS.CANCEL') }}
        </woot-button>
      </div>
    </form>
  </div>
</template>
